export default "__VITE_ASSET__5_nL1UNl__"